interface FreakMeLogoProps {
  size?: number
  className?: string
}

export default function FreakMeLogo({ size = 40, className = '' }: FreakMeLogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient id="freakGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#ff3366" />
          <stop offset="100%" stopColor="#ff6b35" />
        </linearGradient>
        <filter id="glow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur" />
          <feMerge>
            <feMergeNode in="coloredBlur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      
      {/* Outer circle */}
      <circle
        cx="50"
        cy="50"
        r="46"
        stroke="url(#freakGradient)"
        strokeWidth="3"
        fill="none"
        filter="url(#glow)"
      />
      
      {/* Stylized F */}
      <path
        d="M35 28h30c2 0 3.5 1.5 3.5 3.5s-1.5 3.5-3.5 3.5H42v12h20c2 0 3.5 1.5 3.5 3.5s-1.5 3.5-3.5 3.5H42v18c0 2-1.5 3.5-3.5 3.5S35 74 35 72V28z"
        fill="url(#freakGradient)"
      />
      
      {/* Decorative flame element */}
      <path
        d="M70 60c0-8-5-15-12-18 2 5 1 10-3 14-3 3-4 7-2 11 1 2 3 4 6 4 6 0 11-5 11-11z"
        fill="url(#freakGradient)"
        opacity="0.8"
      />
    </svg>
  )
}
